import React from 'react';
import {twMerge} from 'tailwind-merge';

import {SettingType} from '../../../../services/analytics/workspaceSettingsEvents';
import {LinePlotSettings} from '../types';
import {NumberInput} from './NumberInput';

export const NumberRangeInput = ({
  minField,
  maxField,
  minValue,
  maxValue,
  updateSetting,
  trackSetting,
}: {
  minField: 'xAxisMin' | 'yAxisMin';
  maxField: 'xAxisMax' | 'yAxisMax';
  minValue: number | undefined;
  maxValue: number | undefined;
  updateSetting: (settings: Partial<LinePlotSettings>) => void;
  trackSetting: (setting: SettingType, value: string | undefined) => void;
}) => {
  return (
    <div className={twMerge('flex gap-8')}>
      <NumberInput
        placeholder="Min"
        value={minValue}
        updateSetting={(newVal?: number) => {
          updateSetting({[minField]: newVal});
          trackSetting(minField, newVal?.toString());
        }}
      />
      <NumberInput
        placeholder="Max"
        value={maxValue}
        updateSetting={(newVal?: number) => {
          updateSetting({[maxField]: newVal});
          trackSetting(maxField, newVal?.toString());
        }}
      />
    </div>
  );
};
